import { Eye, ListChecks } from "lucide-react";

// Purely informational — never scored, no checkboxes. These GBP fields only
// live in the owner's own dashboard; Google has been showing fewer of them
// on the public profile, so we can no longer verify them ourselves either.
// See L.gbpSelfCheck in i18n.js for the copy and the full rationale.
export default function GbpSelfCheck({ L }) {
  const C = L.gbpSelfCheck;
  if (!C) return null;
  return (
    <div className="mt-6 overflow-hidden rounded-2xl border bg-card shadow-sm" data-testid="gbp-self-check">
      <div className="border-b bg-secondary/50 p-5 sm:p-6">
        <h2 className="mb-1.5 flex items-center gap-1.5 font-heading text-lg font-semibold">
          <Eye className="h-4 w-4" /> {C.title}
        </h2>
        <p className="text-base text-muted-foreground">{C.intro}</p>
      </div>
      <div className="space-y-5 p-5 sm:p-6">
        {C.groups.map((g) => (
          <div key={g.heading}>
            <h3 className="mb-2 flex items-center gap-1.5 text-sm font-semibold uppercase tracking-wide text-muted-foreground">
              <ListChecks className="h-3.5 w-3.5" /> {g.heading}
            </h3>
            <ul className="space-y-2.5">
              {g.items.map((item) => (
                <li key={item.title} className="rounded-xl border bg-secondary/30 p-3.5">
                  <p className="text-base font-medium">{item.title}</p>
                  <p className="mt-1 text-sm text-muted-foreground">{item.why}</p>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
